module.exports = __webpack_public_path__ + "static/media/abancay.9001a09d.webp";